
import { X } from 'lucide-react';

interface ModalHeaderProps {
  onClose: () => void;
}

const ModalHeader = ({ onClose }: ModalHeaderProps) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <h3 className="text-xl font-bold">Join the Adventure</h3>
      <button 
        onClick={onClose}
        className="text-adv-lightGray hover:text-white transition-colors"
      >
        <X size={20} />
      </button>
    </div>
  );
};

export default ModalHeader;
